// extracted by mini-css-extract-plugin
module.exports = {"my-order-page":"MyOrderPage_my-order-page__1mhZE","myOrderPage":"MyOrderPage_my-order-page__1mhZE"};